import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
import { Drawer } from 'antd';
import PropTypes from 'prop-types';
import { MoodTagList } from '~/components';
import {
  monthlyAverageApprovedTags,
  monthlyAverageNotApprovedTags,
  approvedTags,
  notApprovedTags,
} from '~/store/fetchActions/fetchMood';
import { iconsByMood, altTextByMood } from '~/constants/moods';

export default function MoodEmojiTagsDrawer({
  moodIndex,
  isDrawerOpen,
  setIsDrawerOpen,
}) {
  const { week, selectedTower, selectedTowers, smileTags } = useSelector(
    state => state.mood,
  );
  const dispatch = useDispatch();
  const { isLoadingApprovedTags, isLoadingNotApprovedTags } = useSelector(
    state => state.loading,
  );
  const onlyVoted = true;

  useEffect(() => {
    if (week.start && isDrawerOpen) {
      dispatch(monthlyAverageApprovedTags(week, onlyVoted, moodIndex));
      dispatch(monthlyAverageNotApprovedTags(week, onlyVoted, moodIndex));
    }
  }, [
    moodIndex,
    week,
    selectedTower,
    selectedTowers,
    dispatch,
    isDrawerOpen,
    onlyVoted,
  ]);

  const drawerTitle = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div>Tags marcadas por quem avaliou: </div>
        <img
          src={iconsByMood[moodIndex]}
          alt={altTextByMood[moodIndex]}
          style={{ width: '30px', marginLeft: 15 }}
        />
      </div>
    );
  };

  return (
    <Drawer
      title={drawerTitle()}
      placement="right"
      closable={false}
      onClose={() => setIsDrawerOpen(false)}
      visible={isDrawerOpen}
      width={500}
    >
      <MoodTagList
        approvedTags
        tags={smileTags?.approved?.tags}
        loader={isLoadingApprovedTags}
      />
      <MoodTagList
        tags={smileTags?.notApproved?.tags}
        loader={isLoadingNotApprovedTags}
      />
    </Drawer>
  );
}

MoodEmojiTagsDrawer.propTypes = {
  moodIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  setIsDrawerOpen: PropTypes.func.isRequired,
};
